import { Card, Input, Col, Row, Form, Select } from 'antd';
import CustomerPicker2 from 'components/pickers/customer';
import AddressPicker from 'components/pickers/address';
import CollaboratorPicker from 'components/pickers/collaborator';
import { useOrderEditContext } from '../OrderEditContext';

const OrderGeneralCardDesktop = () => {
    const { internalStatuses, workspace, onCustomerChange, selectedCustomerID } = useOrderEditContext();

    return (
        <Card title='Thông tin chung' size='small' extra={null}>
            <div style={{ display: 'block' }}>
                <Form.Item hidden name={'id'}>
                    <Input />
                </Form.Item>

                <Form.Item
                    label='Khách hàng'
                    name={['customer_id']}
                    rules={[{ required: true, message: 'Bạn phải chọn khách hàng' }]}
                >
                    <CustomerPicker2 onCustomerChange={onCustomerChange} />
                </Form.Item>

                <Form.Item
                    label='Địa chỉ giao hàng'
                    name={'shipping_address'}
                    rules={[{ required: true, message: 'Please input customer phone_number!' }]}
                >
                    <AddressPicker customer_id={selectedCustomerID} />
                </Form.Item>

                <Row style={{ width: '100%' }} gutter={8}>
                    <Col span={8}>
                        <Form.Item label='Thanh toán' name={['payment_status', 'id']}>
                            <Select>
                                <Select.Option value='unpaid'>Chờ thanh toán</Select.Option>
                                <Select.Option value='partial'>Thanh toán 1 phần</Select.Option>
                                <Select.Option value='paid'>Đã thanh toán</Select.Option>
                                <Select.Option value='waiting_verification'>Chờ xác nhận thanh toán</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label='Vận chuyển' name={['shipping_status', 'id']}>
                            <Select>
                                <Select.Option value='not_shipped'>Chờ vận chuyển</Select.Option>
                                <Select.Option value='shipping'>Đang vận chuyển</Select.Option>
                                <Select.Option value='shipped'>Đã giao</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item label='Trạng thái nội bộ' name={['internal_status', 'id']}>
                    <Select>
                        {internalStatuses.map((status) => (
                            <Select.Option key={status.id} value={status.id}>{status.title}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item label='Ghi chú' name={['internal', 'note']}>
                    <Input />
                </Form.Item>

                <Form.Item label='Mã vận đơn' name={['shipping_status', 'tracking_code']}>
                    <Input />
                </Form.Item>

                {workspace?.collaboratorSetting?.collaborator && (
                    <Form.Item label='Cộng tác viên' name={'ref_code'}>
                        <CollaboratorPicker />
                    </Form.Item>
                )}
            </div>
        </Card>
    );
};

export default OrderGeneralCardDesktop;
